import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import Shop from '@/pages/Shop'
import FAQ from '@/pages/FAQs'
import PrivacyPolicy from '@/pages/PrivacyPolicy'
import SingleProduct from '@/pages/SingleProduct'
import PageNotFound from '@/pages/404'
import Contact from '@/pages/Contact'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/shop',
      name: 'Shop',
      component: Shop
    },
    {
      path: '/products/:slug',
      component: SingleProduct
    },
    {
      path: '/faq',
      name: 'FAQ',
      component: FAQ
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/privacy-policy',
      name: 'Privacy Policy',
      component: PrivacyPolicy
    },
    {
      path: '*',
      name: 'NotFound',
      component: PageNotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js